import { render, staticRenderFns } from "./VMarketplaceForm.vue?vue&type=template&id=3bcff074"
import script from "./VMarketplaceForm.vue?vue&type=script&lang=js"
export * from "./VMarketplaceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports